import React, { FC, useCallback } from 'react';
import './RightPopup.css';
import CloseIcon from '../../../assets/images/cross.svg';
import Button from '../../UiLib/Button/Button';

interface IRightPopupProps {
    onClose: () => void;
    name: string;
    children: React.ReactNode;
    nonblocking?: boolean;
    width?: number;
}

const RightPopup: FC<IRightPopupProps> = ({
    children,
    name,
    nonblocking,
    width = 550,
    onClose
}) => {
    const handleWrapperClick = useCallback((e: React.MouseEvent) => {
        if (!nonblocking && e.target === e.currentTarget) {
            onClose();
        }
    }, [nonblocking, onClose]);

    const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
        if (e.key === 'Escape' && !nonblocking) {
            onClose();
        }
    }, [nonblocking, onClose]);

    return (
        <div 
            className={`right-popup-wrapper row-align ${nonblocking ? 'nonblocking' : ''}`}
            onClick={handleWrapperClick}
            onKeyDown={handleKeyDown}
            role="dialog"
            aria-modal={!nonblocking}
            aria-label={name}
            tabIndex={-1}
        >
            <div 
                className="right-popup-panel"
                style={{ width: `${width}px` }}
            >
                <div className="right-popup-header row-align">
                    <h2 className="right-popup-title h1_28">{name}</h2>
                    <Button
                        callBack={onClose}
                        image={CloseIcon}
                    />
                </div>
                <div className="right-popup-children-container">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default React.memo(RightPopup);